import { isPlaying } from '../state/player';

/**
 * The three-bar equalizer that marks the row you are listening to.
 *
 * Purely CSS-animated: three spans with staggered `scaleY` keyframes cost nothing per frame
 * on the main thread, where a canvas or an SVG driven from `timeupdate` would repaint a list
 * row several times a second for decoration.
 *
 * Paused keeps the bars but freezes them, so the row still reads as "this is the one" when
 * playback stops. `prefers-reduced-motion` freezes them too, via the global rule in the
 * stylesheet — the meaning survives without the movement.
 */
export function PlayingIndicator({ label = 'Now playing' }: { label?: string }) {
  const playing = isPlaying.value;
  return (
    <span class={`eq ${playing ? 'is-playing' : ''}`} role="img" aria-label={label}>
      <span class="eq__bar" aria-hidden="true" />
      <span class="eq__bar" aria-hidden="true" />
      <span class="eq__bar" aria-hidden="true" />
    </span>
  );
}
